import useMedia from 'react-use/lib/useMedia';
export default () => {
  return useMedia('(prefers-reduced-motion: reduce)');
};